<script>
import { usePageInfo } from '@/plugins/page-info';
import BtnIcon from '../common/BtnIcon.vue';

export default {

  name: 'PageBack',

  components: {
    BtnIcon,
  },

  props: {
    backBtnSize: {
      type: String,
      default: 'sm',
    },
  },

  setup() {

    const { pageInfo } = usePageInfo();

    return {
      pageInfo,
    };
  },

  methods: {
    goBack() {
      const { backHandler, backRouteName } = this.pageInfo;

      if (!backHandler && !backRouteName) return;

      if (typeof backHandler === 'function') backHandler();

      if (backRouteName && typeof backRouteName === 'string') this.$router.push({ name: backRouteName });
    },
  },
};

</script>

<template>
  <div
    v-if="!pageInfo.isLoading"
    class="back-page-wrapper t3 -t_medium"
    :class="{ center: pageInfo.isTitleCentered }"
  >
    <btn-icon
      v-if="pageInfo.backHandler || pageInfo.backRouteName"
      class="back-page-btn"
      icon="arrow-left"
      :size="backBtnSize"
      @click.native="goBack"
    />
    <span>{{ $t(pageInfo.currentPageName) }}</span>
  </div>
</template>

<style lang="scss" scoped>
.back-page-wrapper {
  display: flex;
  align-items: center;
  color: $context-color-3;
  gap: .625rem;

  .back-page-btn {
    &:not(:hover) {
      color: $context-color-1;
    }
  }

  @media screen and (min-width: $tablet-size) {
    margin-bottom: 1.5rem;

    &.center {
      justify-content: center;
    }
  }
}
</style>
